var React = require('react');

function CloseOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.70711 21.7071C4.31658 22.0976 3.68342 22.0976 3.29289 21.7071C2.90237 21.3166 2.90237 20.6834 3.29289 20.2929L11.0858 12.5L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L12.5 11.0858L20.2929 3.29289C20.6834 2.90237 21.3166 2.90237 21.7071 3.29289C22.0976 3.68342 22.0976 4.31658 21.7071 4.70711L13.9142 12.5L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L12.5 13.9142L4.70711 21.7071Z","fill":"#2B271F"}));
}

CloseOutline.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseOutline;

CloseOutline.default = CloseOutline;
